import { render, staticRenderFns } from "./ImagesList.vue?vue&type=template&id=b62b95c4"
import script from "./ImagesList.vue?vue&type=script&lang=ts"
export * from "./ImagesList.vue?vue&type=script&lang=ts"
import style0 from "./ImagesList.vue?vue&type=style&index=0&id=b62b95c4&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b62b95c4')) {
      api.createRecord('b62b95c4', component.options)
    } else {
      api.reload('b62b95c4', component.options)
    }
    module.hot.accept("./ImagesList.vue?vue&type=template&id=b62b95c4", function () {
      api.rerender('b62b95c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/label-layout-editor/ImagesList.vue"
export default component.exports